import * as msg from '../../helpers/console'
import handleListFilters from '../../components/handleListFilters'
import deleteScholarshipsConfirm from '../../components/deleteScholarshipsConfirm'

const init = () => {
  msg.success('ListScholarshipsController', 'Ready!')
  new handleListFilters().init();
  new deleteScholarshipsConfirm().init();
}

export default init
